import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { InviteStatusType } from '../../services/server-types';
import { MembersTableState, TeamMemberTableRowData } from '../types';
import { getExpiredMembers, getPendingMembers, getPendingOwners, StatusFilterSuffix } from './TeamMembersListComponents';
import * as css from './TeamMembersList.scss';
import WarningIconSmall from 'wix-ui-icons-common/StatusWarningFilledSmall';
import { Dropdown, TableToolbar, Box } from 'wix-style-react';

interface IProps extends InjectedTranslateProps {
  data: TeamMemberTableRowData[];
  membersTable: MembersTableState;

  onStatusFilterChanged(status: InviteStatusType): void;
}

interface IState {
  dropdownClose: boolean;
}

class TeamMembersListStatusFilter extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      dropdownClose: true,
    };
  }

  onOptionsShow = () => {
    this.setState({
      dropdownClose: false,
    });
  }

  onOptionsHide = () => {
    this.setState({
      dropdownClose: true,
    });
  }

  getValueTextById = (id, showNumber: boolean = true) => {
    const { t, data } = this.props;
    const pendingMembers = data.filter(getPendingMembers);
    const expiredMembers = data.filter(getExpiredMembers);
    const pendingOwners = data.filter(getPendingOwners);
    switch (id) {
      case 0:
        return t('teamDetails.actions.statusFilter.allOption') + (showNumber ? ` (${data.length})` : '');
      case 1:
        return `${t('teamDetails.actions.statusFilter.pendingOwnership')} (${pendingOwners.length})`;
      case InviteStatusType.PENDING:
        return t('list.pending') + (showNumber ? ` (${pendingMembers.length})` : '');
      case  InviteStatusType.EXPIRED:
        return t('list.expired') + (showNumber ? ` (${expiredMembers.length})` : '');
      default:
        return '';
    }
  }

  valueParser = (option) => {
    return option.id ? this.getValueTextById(option.id, false) : '';
  }

  render() {
    const {
      t,
      data,
      onStatusFilterChanged,
      membersTable,
    } = this.props;
    const { dropdownClose } = this.state;

    const expiredMembers = data.filter(getExpiredMembers);
    const pendingMembers = data.filter(getPendingMembers);

    let statusOptions = [
      { id: 0, value: this.getValueTextById(0) },
      { id: InviteStatusType.PENDING, value: this.getValueTextById(InviteStatusType.PENDING),
        disabled: !pendingMembers.length },
      { id: InviteStatusType.EXPIRED, value: (<Box align="space-between" verticalAlign="middle" width="100%">
          <Box>{this.getValueTextById(InviteStatusType.EXPIRED)}</Box>
          {!!expiredMembers.length && <Box><WarningIconSmall className={css.statusFilterSuffix}/></Box>}
      </Box>), disabled: !expiredMembers.length},
    ];
    if (data.find(item => item.isPendingOwner)) {
      statusOptions.push({ id: 1, value: this.getValueTextById(1) });
    }

    const suffix = (dropdownClose && expiredMembers.length > 0 && membersTable.filters.status !== InviteStatusType.EXPIRED) && <StatusFilterSuffix />;

    return (
      <Box>
        <TableToolbar.Label>
          {t('teamDetails.actions.statusFilter.title')}
        </TableToolbar.Label>
        <span style={{ marginLeft: '14px' }}>
          <Dropdown
            autoSelect={false}
            onSelect={option => onStatusFilterChanged(option.id as InviteStatusType)}
            options={statusOptions}
            selectedId={membersTable.filters.status || 0}
            data-hook="account-team-table-status-filter"
            suffix={suffix}
            roundInput
            onOptionsShow={this.onOptionsShow}
            onOptionsHide={this.onOptionsHide}
            valueParser={this.valueParser}
            className={suffix ? css.statusFilterDropdownWithSuffix : css.statusFilterDropdown}
            placeholder={t('teamDetails.actions.statusFilter.placeholder')}
          />
        </span>
      </Box>
    );
  }
}

export default translate()(TeamMembersListStatusFilter);
